<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <circle
      :cy="props.size / 2"
      fill="currentColor"
      cx="6.5"
      r="1.5"
    />
    <circle
      :cy="props.size / 2"
      fill="currentColor"
      cx="12.5"
      r="1.5"
    />
    <circle
      :cy="props.size / 2"
      fill="currentColor"
      cx="18.5"
      r="1.5"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
